import {first, get, last} from "lodash";
import {EventStatus, RoundStatus} from "modules/enums";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";
import {getViewedEvent} from "modules/selectors/events";

export const getSelectedRoundID = ({events}: IStore) => events.selectedRoundID;

export const getViewedEventRounds = createSelector(getViewedEvent, (event) => {
	return get(event, "rounds", []);
});

export const getActualRound = createSelector(getViewedEventRounds, (rounds) => {
	const activeRound = rounds.find(({status}) => status === RoundStatus.Active);
	const scheduleRounds = rounds.filter(({status}) => status === RoundStatus.Scheduled);

	return activeRound || first(scheduleRounds) || last(rounds);
});

export const getActualRoundId = createSelector(getActualRound, (round) => round?.id);

export const getViewedRoundID = createSelector(
	getActualRound,
	getSelectedRoundID,
	(actualRound, selectedRoundID) => {
		return selectedRoundID || actualRound?.id;
	}
);

export const getViewedRound = createSelector(
	getViewedRoundID,
	getViewedEventRounds,
	(roundId, rounds) => {
		return rounds.find(({id}) => id === roundId);
	}
);

export const getIsShowPlayerPool = createSelector(getViewedEvent, (event) => {
	return event?.status === EventStatus.Scheduled;
});
